import {
	GotoCleanLabelProducts,
	GotoKehe,
	GotoLgbtqProducts,
	GotoNewtoMarketProducts,
	GotoNextyProducts,
	GotoPrivateProducts
} from '../Cta/Cta';

interface INewtopiaTopCardsProps {
	className: string;
	privateTitle?: string;
	cleanLabelTitle?: string;
}

export const NewtopiaTopCards = ({
	className,
	privateTitle,
	cleanLabelTitle
}: INewtopiaTopCardsProps) => (
	<div className={className}>
		<div className='cardPrivate'>
			<GotoPrivateProducts title={privateTitle} />
		</div>
		<div className='cardLabel'>
			<GotoCleanLabelProducts title={cleanLabelTitle} />
		</div>
		<div className='cardNexty'>
			<GotoNextyProducts />
		</div>
	</div>
);

export const NewtopiaBottomCards = ({ className }: { className: string }) => (
	<div className={className}>
		<div className='cardMinority'>
			<GotoLgbtqProducts />
		</div>
		<div className='cardKehe'>
			<GotoKehe />
		</div>
	</div>
);

interface INewtopiaMarketCardProps {
	cardClassName: string;
	wrapperClassName?: string;
}

export const NewtopiaMarketCard = ({
	cardClassName,
	wrapperClassName
}: INewtopiaMarketCardProps) => {
	const card = (
		<div className={cardClassName}>
			<GotoNewtoMarketProducts />
		</div>
	);

	return wrapperClassName ? <div className={wrapperClassName}>{card}</div> : card;
};
